import Link from "next/link";
import Image from "next/legacy/image";
import { fitIn } from "@/utils/imageHandler";

function SpecialReportCardItem(props) {
  const image_url = props.cover_image_url
    ? fitIn(props.cover_image_url, 600)
    : `https://source.unsplash.com/600x1000?cover+magazine`;

  return (
    <Link legacyBehavior href={`/reports/${props.slug}`} passHref>
      <a className='relative group'>
        {/* <div className="p-2px rounded-[15px] right-0 bottom-0 absolute w-[94%] h-[94%] opacity-0 duration-300 ease-out lg:group-hover:opacity-100 lg:group-hover:translate-x-2 lg:group-hover:translate-y-2 bg-gradient-to-r from-yellow-1 to-red-1 mb-4">
          <div className="rounded-[14px] w-full h-full bg-dark-2"></div>
        </div> */}
        <div
          className={`${
            props.thumbnail_orientation === "landscape"
              ? "aspect-[4/3]"
              : "aspect-[3/4]"
          } relative z-10 overflow-hidden max-h-[300px] lg:max-h-[380px] transition-transform duration-300 `}
        >
          <Image
            src={image_url}
            alt={props.cover_image_alt}
            width={300}
            height={400}
            objectFit='cover'
          />
        </div>
      </a>
    </Link>
  );
}

export default SpecialReportCardItem;
